import { Dialog, Button, DialogContent, DialogActions, DialogContentText, Box} from "@mui/material"
import { Mail } from '@mui/icons-material'
import { Form, TextInput, email, required, useGetOne, useNotify, useTranslate } from 'react-admin'
import { useState } from "react"
import { apiService } from "../../apiService";
import { MailServiceConfigTestQuery, UserReadModel } from "../../GeneratedClients/FreeBillApi";
import CustomCommandProgress from "../../customStyles/CustomCommandProgress";
import { useMutation } from "react-query";


const EmailServiceConfigTestButton = ({userId}: {userId: string}) => {
  
  const translate = useTranslate()
  //@ts-ignore
  const { data: user, isLoading: userLoading} = useGetOne<UserReadModel>("users", {id: userId})
  const notify = useNotify()
  const [open, setOpen] = useState<boolean>(false)
  const { mutate: sendTestMail, isLoading } = useMutation((command: MailServiceConfigTestQuery) => 
      apiService.UsersApi.mailServiceConfigTest({mailServiceConfigTestQuery: command, userId: userId}),
    {
      onSuccess: (data) => {
        notify(translate(`resources.mailServiceConfig.message.${data.data === true ? 'success' : 'error'}`), {type: data.data === true ? 'info' : 'error'})
        handleClose()
      },
      onError: (error: any) => {
        notify(`${error}`, {type: 'error'})
      }
    }   
  )

  const handleOpen = () => {
    user?.mailServiceConfig ? setOpen(true) : notify(translate("resources.mailServiceConfig.message.notConfigured"))
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async(formData: any) => {
    const request: MailServiceConfigTestQuery = {
      userId: userId,
      toAddress: formData.toAddress
    }
    sendTestMail(request)
  }

  if(userLoading) return null

  return (
    <>
      <Button 
        size='small' 
        sx={{lineHeight: 1.5}} 
        startIcon={<Mail />}
        onClick={handleOpen}
      >
        {translate('resources.mailServiceConfig.action.testMail')}
      </Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <Form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              {translate('resources.mailServiceConfig.action.send')}
            </DialogContentText>
            <DialogContentText mt={2}>
              <TextInput source="toAddress" label="Empfänger" validate={[email(), required()]} />
            </DialogContentText>
            { isLoading && <Box mt={2}><CustomCommandProgress /></Box> }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
            <Button disabled={isLoading} type="submit" >{translate('resources.mailServiceConfig.action.send')}</Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  )
}

export default EmailServiceConfigTestButton